module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctc2a",
    attrs: {
      "id": "ch1"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e62"
    }
  }, [_vm._v("Did you know that Tex-Mex cooking is the oldest regional cuisine in America? You would think that such a time-honored cuisine would have clear-cut recipes and menus and be easy to define. But it's hard to say exactly what Tex-Mex cooking is. There are as many definitions as there are dishes!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e63"
    }
  }, [_vm._v("Generally, Tex-Mex cooking consists of recipes and foods native to Mexico, updated with the foods and customs of the state of Texas and, as the cuisine expanded, France, Spain, and the rest of America. These recipes range from Frito Pie to Caramel Flan, from Barbecued Brisket to Ceviche, and the foods include everything from processed cheese food to fresh herbs, shrimp, lard, chiles, and tortilla chips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e64"
    }
  }, [_vm._v("Tex-Mex cooking is scorned by many sophisticated cooks and restaurants, but it can be a delicious and inventive style of cooking. Of course, ingredients such as yellow cheese, raw onion, and refried beans can be used judiciously and well, or can be overdone. The food can be complex and subtle or truly searing and obvious, depending on the taste and mood of the cook.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e65"
    }
  }, [_vm._v("Of all the Tex-Mex, Texas, and Mexican cookbooks on the market, very few have included some commonly used appliances: the crockpot and the indoor dual-contact grill. Since these tools save time and money and produce high quality foods, they have been incorporated into the book. Crockpot Ranch Casserole made in the crockpot is creamy and rich and is ready when you get home. Texas Toast Grilled Sandwiches and Cheese Quesadillas are crisp, golden, and perfectly done when made in a dual-contact grill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e66"
    }
  }, [_vm._v("If you are following a special diet, whether low-fat, low-carb, or South Beach, Tex-Mex cooking can fit into your lifestyle. If you are eating low-carb, most of the meat and vegetable dishes are made for your diet. For low-fat devotees, the vegetarian, side dish, and salad recipes are all good choices. The special foods of Tex-Mex cooking, especially chiles and sauces, are excellent choices to add flavor and variety to any diet and many recipes. And the most commonly used ingredients, corn and chiles, are very high in vitamin content, especially vitamins A and C.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e67"
    }
  }, [_vm._v("Sauces are very important in Tex-Mex cooking. Once you have mastered Enchilada Sauce, Chili Gravy, and different types of salsas, you will be able to make most dishes in this cuisine. Read the chapter on sauces carefully, as they are the finishing touch to many recipes in the book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e68"
    }
  }, [_vm._v("As in all cooking, you choose the level of seasoning and spices. If your family isn't fond of spicy hot food, omit the chile peppers in these recipes or substitute milder peppers for the hotter varieties. Use parsley instead of cilantro for a milder taste, and choose ground black pepper over red pepper flakes for less heat. You can also increase the heat level. Learn about the heat and flavors of chile peppers and spices and you will always be able to control the taste of the food you serve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e69"
    }
  }, [_vm._v("This book will teach you about the foods, cooking techniques, and tastes of Tex-Mex cooking. You'll learn about calcabacita, nopales, burritos, pasilla chiles, quesadillas, enchiladas, tacos, epazote, churros, chalupas, frijoles, gorditas, and more, expanding your knowledge of the world along with your kitchen repertoire. There's no better way to travel without leaving your home than to learn a new cuisine.")]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "d7e70"
    }
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "cook-book_comm2",
      "src": "images/cook-book_comm2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a36110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth_ISBNXXXXXXXXX_epub_c7_r1.vue
// module id = 81
// module chunks = 0